// Phase C.7 — Fly 10 average speed, derived from raw elapsed time —
// never stored. Mirrors fortyYardSpeed.js's own shape exactly, but with
// its OWN 10-yard distance constant: 40-yard and Fly 10 are both
// elapsed-time sprint tests, but they measure different distances and
// must never share one conversion factor. This is average speed over
// the measured 10-yard "fly" segment, not a directly radar/GPS-measured
// top speed — a genuinely different capture method this app doesn't
// support yet (see migration 048's own header for why that's a
// separate, deferred concern, not conflated with this one).
//
// mph = 20.4545455 / seconds  (20.4545455 = (10 yards in miles) *
// 3600s/hr = (10/1760) * 3600)
const FLY_TEN_MPH_CONSTANT = 20.4545455;

export function flyTenAvgMph(seconds) {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds) || seconds <= 0) return null;
  return Math.round((FLY_TEN_MPH_CONSTANT / seconds) * 100) / 100;
}
